module.exports = __webpack_public_path__ + "img/ic_corner-up-right.7ab5e239.svg";